import {HttpErrorResponse} from '@angular/common/http';
import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {catchError, forkJoin, map, ObservableInput, of} from 'rxjs';
import {ErrorCodes} from '../../constants/ErrorCodes';
import {NotificationService} from '../../services/notification.service';
import {RemitoService} from '../../services/remito.service';

@Component({
  selector: 'app-print-email-remitos-button',
  templateUrl: './print-email-remitos-button.component.html',
  styleUrls: ['./print-email-remitos-button.component.scss']
})
export class PrintEmailRemitosButtonComponent implements OnInit {

  public isPrint: boolean = true;
  private _remitos: { ptoEmision: string, nroRemito: number }[] = [];
  _disabled = false;
  isLoading = false;
  errors: HttpErrorResponse[] = [];

  @Input('disabled')
  set disabled(disabled: boolean) {
    this._disabled = disabled;
  }

  @Input('remitos')
  set remitos(remitos: { ptoEmision: string, nroRemito: number }[]) {
    this._remitos = remitos;
  }

  @Input('type')
  set type(type: 'print' | 'email') {
    this.isPrint = type === 'print';
  }

  @Output() printEmailCompletedEvent = new EventEmitter<void>();

  constructor(
    private readonly remitoService: RemitoService,
    private readonly notificationService: NotificationService
  ) {
  }

  ngOnInit(): void {
  }

  printRemitos() {
    const obs: ObservableInput<any>[] = [];
    this._remitos.forEach((remito) => {
      obs.push(
        this.remitoService.downloadPdf(remito.nroRemito).pipe(
          map((res) => {
            const pdfFile = new Blob([res], {type: 'application/pdf'});
            const data = window.URL.createObjectURL(pdfFile);
            const link = document.createElement('a');
            link.href = data;
            link.download = remito.ptoEmision + " - " + remito.nroRemito + `.pdf`;
            link.click();
            //this.setPrinted(element.nroRemito);
          }),
          catchError((error) => {
            this.errors.push(error);
            return of(null);
          })
        )
      );
    });
    this.executeObs(obs);
  }


  emailRemitos() {
    const obs: ObservableInput<any>[] = [];
    this._remitos.forEach((remito) => {
      obs.push(
        this.remitoService.emailPdf(remito.nroRemito).pipe(
          catchError((error) => {
            this.errors.push(error);
            return of(null);
          })
        )
      );
    });
    this.executeObs(obs);
  }

  executeObs(obs: ObservableInput<any>[]) {
    this.isLoading = true;
    forkJoin(obs).subscribe({
      complete: () => {
        if (this.errors.length > 0) {
          const errorType = this.isPrint ? ErrorCodes.PRINTED_FAILED : ErrorCodes.EMAIL_FAILED;
          this.notificationService.open(errorType,'error')
        } else if (!this.isPrint) {
          this.notificationService.open(ErrorCodes.EMAIL_SUCCESS, 'success');
        }
        this.errors = [];
        this.isLoading = false;
        this.printEmailCompletedEvent.emit();
      }
    });
  }

}
